import React from 'react'
import { AuthWrapper } from '../../style';
import { useDispatch, useSelector } from 'react-redux';
import { switchToEkycFlow } from '../../../../../../redux/authentication/actionCreator';


function Ekyc() {
    
    const dispatch = useDispatch();
    const nric = useSelector(state => state.auth.dataForm.nric);
    const name = useSelector(state => state.auth.dataForm.name);
    const age = useSelector(state => state.auth.dataForm.age);
    const isLoading = useSelector(state => state.auth.loading);
    const kycToken = useSelector(state => state.auth.dataForm.kycToken);
    const customerId = useSelector(state => state.auth.dataForm.customerId);
    const url=window.location.href;
    const CALL_BACK_API_URL = process.env.REACT_APP_CALL_BACK_API_URL;

    function randomNumberInRange(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }
    
    const switchToEkycFlowFn = () => {
        
        const referenceId=customerId+randomNumberInRange(100,999)
        const reDirectUrl=`${url}?referenceId=${referenceId}`
        const workflow={captureMethod:'CAMERA',verificationType:'ID_AND_IDENTITY'}
        const callBackUrl={success:reDirectUrl,error:reDirectUrl,callback:`${CALL_BACK_API_URL}`}
        const params = {
            clientCode: 'REFERRAL',
            name: `${name}`,
            referenceId:`${referenceId}`,
            idType:'NRIC',
            idNumber:`${nric}`,
            age:`${age}`,
            url:callBackUrl,
            workflow:workflow

        }
        if(!isLoading&&customerId!==''){
            console.info("switching To Ekyc Flow");
            dispatch(switchToEkycFlow(params,kycToken) )
        }
    }

    return (
        <>
            {switchToEkycFlowFn()}
        </>
    )
}

export default Ekyc